import { gql } from '@apollo/client';

export const READ_VERIFICATION_STATUS = gql`
  query ReadVerificationStatus(
    $externalVerificationType: ExternalVerificationType!
    $verificationId: String!
  ) {
    readVerificationStatus(
      externalVerificationType: $externalVerificationType
      verificationId: $verificationId
    ) {
      id
      status
      customerUid
      externalVerificationType
      verificationMethod
      verificationCriteria {
        externalVerificationType
        email
        context
      }
      errorMessage
      errorCode
    }
  }
`;
